const cards = [
  {
    image: "https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20depicting%20ancient%20Chinese%20palace%20interior%20with%20flowing%20silk%20curtains%20and%20warm%20golden%20candlelight%2C%20elegant%20traditional%20costumes%2C%20dramatic%20chiaroscuro%20lighting%2C%20period%20drama%20aesthetic%2C%20rich%20crimson%20and%20gold%20color%20palette%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field%2C%20no%20text&width=600&height=400&seq=tomato-card-01&orientation=landscape",
    title: '古装大剧扎堆回归，服化道全面升级',
    tag: '热播推荐',
    desc: '今年古装剧市场迎来黄金期，多部S级大制作同步热播，精良考究的服化道和电影级画面质感引发全网讨论。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20modern%20urban%20cityscape%20at%20twilight%20with%20warm%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20romantic%20atmosphere%2C%20two%20silhouettes%20walking%20along%20a%20tree-lined%20street%2C%20soft%20bokeh%20city%20lights%2C%20contemporary%20romance%20drama%20vibe%2C%20cinematic%20color%20grading%20with%20warm%20amber%20tones%2C%20no%20text&width=600&height=400&seq=tomato-card-02&orientation=landscape",
    title: '都市甜宠持续霸榜，治愈系剧情温暖寒冬',
    tag: '人气飙升',
    desc: '多部都市情感剧凭借轻松治愈的剧情和超强CP感持续走红，成为近期追剧圈的社交货币。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20moody%20detective%20office%20with%20evidence%20board%20covered%20in%20red%20strings%20and%20photos%2C%20venetian%20blind%20shadows%2C%20a%20single%20desk%20lamp%20casting%20dramatic%20light%2C%20film%20noir%20inspired%20suspense%20thriller%20atmosphere%2C%20deep%20shadows%20and%20warm%20highlights%2C%20no%20text&width=600&height=400&seq=tomato-card-03&orientation=landscape",
    title: '悬疑推理赛道爆发，高能反转口碑出圈',
    tag: '口碑佳作',
    desc: '悬疑题材迎来井喷期，多部12集精品短剧凭借扎实剧本和层层反转赢得豆瓣高分，成为追剧党必看。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20peaceful%20Japanese%20style%20room%20with%20tatami%20mats%20and%20sliding%20paper%20doors%2C%20morning%20sunlight%20streaming%20through%20shoji%20screens%2C%20a%20small%20wooden%20table%20with%20tea%20set%2C%20minimalist%20zen%20aesthetic%2C%20warm%20natural%20tones%2C%20serene%20and%20healing%20atmosphere%2C%20no%20text&width=600&height=400&seq=tomato-card-04&orientation=landscape",
    title: '日韩新番同步上线，字幕组极速跟进',
    tag: '海外精选',
    desc: '番茄影视大全日韩剧频道全面升级，与播出同步更新中文字幕，多部高分韩剧日剧强势登陆。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20cozy%20living%20room%20scene%20with%20a%20large%20TV%20screen%20displaying%20colorful%20abstract%20visuals%2C%20comfortable%20couch%20with%20throw%20blankets%2C%20warm%20ambient%20lighting%20from%20floor%20lamp%2C%20movie%20night%20atmosphere%2C%20modern%20home%20theater%20setup%2C%20inviting%20and%20relaxed%20vibe%2C%20no%20text&width=600&height=400&seq=tomato-card-05&orientation=landscape",
    title: '短剧赛道异军突起，碎片化追剧成新趋势',
    tag: '新锐潮流',
    desc: '每集10分钟以内的精品短剧正在改变追剧方式，节奏快、爽点密集，完美适配通勤和午休场景。',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-600">编辑团队为你精选的追剧指南</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 2).map((card) => (
            <div
              key={card.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2">{card.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
          {cards.slice(2).map((card) => (
            <div
              key={card.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2">{card.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}